'use client';
/**
 * @param {{commonHeader:string}} data
 */
import React, { useEffect, useState } from "react";
import TossUpChallenge from "../../components/TossUpChallenge";
import { fetchTossUpChallenge } from "../../api/cms";

import "./styles.scss";

const TossUpChallengeEmbed = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [ad, setAd] = useState({});
  const [googleAd, setGoogleAd] = useState({});
  const [tossUpProps, setTossUpProps] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchTossUpChallenge();
      if (data.error === true) {
        return;
      }
      const {
        ad,
        config,
        page,
        puzzles: { rows },
      } = data;
      setIsLoaded(true);
      setAd(ad);
      setGoogleAd(googleAd);
      setTossUpProps({ puzzles: rows, config: config });
    };

    fetchData();
  }, []);

  const { puzzles = null, config = null } = tossUpProps;

  return (
    <>
      { (tossUpProps) ? (
        <div className="">
          <TossUpChallenge puzzles={puzzles} config={config} />
        </div>
        ) : (
          <div>No toss-up challenge found.</div>
        )
      }
    </>
  );

};

export default TossUpChallengeEmbed;
